module.exports = __webpack_public_path__ + "frontend/images/agents/mr-tan-dedicated-xs-73613d27b1fac624ba7d623b43962465.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/frontend/images/agents/mr-tan-dedicated-xs.jpg
// module id = 355
// module chunks = 2